<template>
    <div class="pageBox">
        <img :src="this.$store.state.backImg==null?'../assets/images/logo.png':this.$store.state.backImg"
             alt=""
             class="back">
        <div class="logonFrame">
            <div class="logonBox">
                <span class="title">ZAJC 中安检测</span>
                <span class="hello">欢迎注册中安商城!</span>
                <div class="editBox">
                    <div class="titleRow">
                        <span>*</span>
                        <div class="titleText">手机号：</div>
                    </div>
                    <input type="number" placeholder="手机号" :class="{error:isShowTips1}"
                           @blur="isLegal($event,1),isNull($event,1)" v-model="phone"/>
                    <div class="tipsBox">
                        <span class="tips" v-show="isShowTips1">{{ tips1 }}</span>
                    </div>
                    <div class="titleRow">
                        <span>*</span>
                        <div class="titleText">验证码：</div>
                    </div>
                    <div class="verifyBox">
                        <input type="text" placeholder="请输入验证码(区分大小写)" class="verify" :class="{error:isShowTips2}"
                               @blur="isLegal($event,2),isNull($event,2)"
                               v-model="verify">
                        <div class="VerifyImg" @click="getVerify">
                            <img :src="verifyImg" alt="验证码"/>
                        </div>
                    </div>
                    <div class="tipsBox">
                        <span class="tips" v-show="isShowTips2">{{ tips2 }}</span>
                    </div>
                    <div class="titleRow">
                        <span>*</span>
                        <div class="titleText">密码：</div>
                    </div>
                    <input type="password" placeholder="请输入8至16位英文和数字组合字符" @blur="isLegal($event,3),isNull($event,3)"
                           v-model="pass" :class="{error:isShowTips3}">
                    <div class="tipsBox">
                        <span class="tips" v-show="isShowTips3">{{ tips3 }}</span>
                    </div>
                    <div class="titleRow">
                        <span>*</span>
                        <div class="titleText">确认密码：</div>
                    </div>
                    <input type="password" placeholder="英文和数字组合" @blur="isLegal($event,4),isNull($event,4)"
                           v-model="pass2" :class="{error:isShowTips4}">
                    <div class="tipsBox">
                        <span class="tips" v-show="isShowTips4">{{ tips4 }}</span>
                    </div>
                </div>
                <div class="register" @click="registerRequest">注册</div>
                <div class="bottomRow">
                    <router-link to="/Login" class="login">←前往登录</router-link>
                    <div class="agree">
                        <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
                        <div class="agreement" @click="dialogShow(1)">《会员注册协议》</div>
                    </div>
                </div>
                <div class="agreeBox">
                    <div class="agreement" @click="dialogShow(2)">《ZAJC中安检测隐私协议》</div>
                </div>
            </div>
        </div>
        <el-dialog
            :title="headerTitle"
            :visible.sync="dialogVisible"
            style="margin: auto auto"
            width="40%">
            <div
                class="agreementPop"
                v-html="dialogContent"></div>
            <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="dialogVisible = false;checked = true">我已阅读并同意此协议</el-button>
  </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "login",
    data() {
        return {
            activeName: 'first',
            isShowTips1: false,
            isShowTips2: false,
            isShowTips3: false,
            isShowTips4: false,
            tips1: '',
            tips2: '',
            tips3: '',
            tips4: '',
            phone: null,
            verify: null,
            pass: null,
            pass2: null,
            //复选框值
            checked: false,
            verify_isGo: true,
            login_isGo: true,
            verifyImg: '',
            verifyKey: '',
            //协议标题
            headerTitle: '',
            dialogContent: '',
            //协议是否弹窗
            dialogVisible: false
        }
    },
    mounted() {
        document.title = '注册' + this.$suffix
        this.getVerify()
    },
    methods: {

        /**
         * 获取验证码
         **/
        getVerify() {
            if (this.verify_isGo) {
                this.verify_isGo = false
                setTimeout(() => {
                    this.verify_isGo = true
                }, 1000)
                this.$get('/V1/VerifyCode/GetAuthCode', {})
                    .then((res) => {
                        // console.log('验证码', res)
                        this.verifyImg = res.response.img
                        this.verifyKey = res.response.key
                    })
                    .catch(() => {
                        this.$message.error("网络错误，请重试");
                    });
            } else {
                this.$message.error('请勿频繁刷新!')
            }
        },

        /**
         * 打开弹窗
         **/
        open() {
            this.$confirm('是否同意会员注册协议、隐私协议', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.checked = true
            })
                .catch(() => {
                })
        },

        /**
         * 注册
         **/
        registerRequest() {
            if (this.phone == null || this.pass == null || this.pass2 == null || this.verify == null
                || this.isShowTips1 == true || this.isShowTips2 == true || this.isShowTips3 == true || this.isShowTips4 == true) {
                this.$message.error('请规范输入!')
            } else if (!this.checked) {
                this.open()
            } else {
                if (this.login_isGo) {
                    this.login_isGo = false
                    setTimeout(() => {
                        this.login_isGo = true
                    }, 2200)
                    this.$post('/V1/User/UserRegister', {
                        "phone": this.phone,
                        "pwd": this.pass,
                        "rePwd": this.pass2,
                        "code": this.verify,
                        "globalId": this.verifyKey
                    })
                        .then((res) => {
                            if (res.success) {
                                this.$message.success('注册成功')
                                setTimeout(() => {
                                    this.$router.push('/Login')
                                }, 1500)
                            } else {
                                this.$message.error(res.msg)
                            }
                        })
                        .catch(() => {
                            this.$message.error("网络错误，请重试");
                        });
                }
            }
        },


        /**
         * 判空
         */
        isNull(e, index) {
            let isShow = false
            let tmp1 = null
            let tmp2 = '不能为空';
            if (e.target.value == '') {
                isShow = true
                switch (index) {
                    case 1:
                        tmp1 = '手机号'
                        this.tips1 = tmp1 + tmp2
                        this.isShowTips1 = isShow
                        break;
                    case 2:
                        tmp1 = '验证码'
                        this.tips2 = tmp1 + tmp2
                        this.isShowTips2 = isShow
                        break;
                    case 3:
                        tmp1 = '密码'
                        this.tips3 = tmp1 + tmp2
                        this.isShowTips3 = isShow
                        break;
                    case 4:
                        tmp1 = '确认密码'
                        this.tips4 = tmp1 + tmp2
                        this.isShowTips4 = isShow
                        break;
                }
            }
        },

        /**
         * 输入是否合法
         */
        isLegal(e, index) {
            let isShow = false
            let tmp1 = null
            let tmp2 = '不规范';
            switch (index) {
                case 1:
                    if (e.target.value.length != 11 || !this.$isPhone(e.target.value)) {
                        isShow = true
                    }
                    tmp1 = '手机号'
                    this.tips1 = tmp1 + tmp2
                    this.isShowTips1 = isShow
                    break;
                case 2:
                    if (e.target.value.length != 4) {
                        isShow = true
                    }
                    tmp1 = '验证码'
                    this.tips2 = tmp1 + tmp2
                    this.isShowTips2 = isShow
                    break;
                case 3:
                    this.tips3 = '请输入8至16位英文和数字组合字符!'
                    if (e.target.value.length < 8 || e.target.value.length > 16) {
                        isShow = true
                    }
                    this.isShowTips3 = isShow
                    break;
                case 4:
                    if (this.pass2 != this.pass) {
                        isShow = true
                    }
                    this.tips4 = '两次密码输入不一致'
                    this.isShowTips4 = isShow
                    break;
            }
        },

        /**
         *
         */
        dialogShow(type) {
            this.dialogVisible = true
            if (type == 1) {
                this.headerTitle = '《会员注册协议》'
                this.dialogContent = this.$re_treaty
            } else {
                this.headerTitle = '《ZAJC中安检测隐私协议》'
                this.dialogContent = this.$pr_treaty
            }

        }
    }
}
</script>

<style scoped lang="less">
::v-deep .el-checkbox__label {
    color: #333 !important;
}

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type="number"] {
    -moz-appearance: textfield;
}

.pageBox {
    width: 100%;
    height: 800px;
    position: relative;
    background-color: #cccccc;

    .back {
        width: 100%;
        height: 100%;
    }

    .logonFrame {
        width: 1210px;
        margin: 0 auto;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;

        .logonBox {
            width: 450px;
            height: 600px;
            box-shadow: 0px 0px 6px 0px #cccccc;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            background-color: white;
            justify-content: center;

            .title {
                font-size: 35px;
                color: #1f2d5c;
                font-weight: bold;
            }

            .hello {
                font-size: 20px;
                color: #1f2d5c;
                margin: 5px 0px 15px;
            }

            .editBox {
                width: 350px;
                display: flex;
                flex-direction: column;


                .titleRow {
                    display: flex;
                    flex-direction: row;

                    span {
                        color: #F56C6C;
                    }

                    .titleText {
                        display: flex;
                        flex-direction: column;
                        font-size: 14px;
                        margin-left: 5px;
                    }
                }

                .verifyBox {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;

                    .verify {
                        width: 210px;
                        height: 40px;
                    }

                    .VerifyImg {
                        border: 1px solid #cccccc;
                        border-radius: 3px;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        width: 80px;
                        height: 40px;
                        overflow: hidden;
                        cursor: pointer;

                        img {
                            max-width: 100%;
                            max-height: 100%;
                        }
                    }
                }

                .error {
                    border: 1px solid #F56C6C;
                }

                input {
                    border: 1px solid #ccc;
                    border-radius: 3px;
                    outline: #1f2d5c;
                    padding: 0px 20px;
                    height: 50px;
                    font-size: 16px;
                    color: #333;
                }

                input::placeholder {
                    color: #cccccc;
                }

                .tipsBox {
                    height: 16px;
                    min-height: 16px;
                    line-height: 13px;
                    margin-bottom: 3px;

                    .tips {
                        color: #F56C6C;
                        font-size: 12px;
                    }
                }
            }

            .register {
                border: 1px solid #1f2d5c;
                border-radius: 3px;
                height: 42px;
                width: 350px;
                line-height: 42px;
                font-size: 14px;
                text-align: center;
                margin: 5px 0px 15px;
                cursor: pointer;
                color: white;
                background-color: #1f2d5c;
            }

            .bottomRow {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                font-size: 14px;
                width: 350px;

                .login {
                    color: #333;
                }

                .agree {
                    display: flex;
                    flex-direction: row;
                    align-content: center;
                }
            }

            .agreeBox {
                display: flex;
                flex-direction: row;
                justify-content: flex-end;
                width: 350px;
                font-size: 14px;
                margin-top: 2px;
            }

            .agreement {
                color: #409EFF;
                cursor: pointer;
            }
        }
    }

    .agreementPop {
        height: 550px;
        overflow: auto;
    }
}
</style>
